import React from "react";
import {Divider} from "../../../../designSystem/components/Divider";
import {ContactRow} from "../ContactRow";
import {CONTACTS} from "../../model/contacts";
import {Typography} from "../../../../designSystem/components/Typography";

export const ContactFeature = () => (
  <div className="w-full md:w-[650px] max-w-full bg-white rounded-lg m-auto overflow-hidden">
    <div className="px-4 py-3 grid grid-cols-[60%_40%] gap-4 items-center bg-gray-200 text-center">
      <Typography variant="bodyBold">
        單位
      </Typography>
      <Typography variant="bodyBold">
        聯繫電話
      </Typography>
    </div>
    <Divider/>
    {CONTACTS.map(contact => (
      <React.Fragment key={contact.title}>
        <ContactRow
          title={contact.title}
          groups={contact.groups}
          contact={contact.contact}
          contacts={contact.contacts}
        />
        <Divider />
      </React.Fragment>
    ))}
  </div>
)
